export default {"src":"/_next/static/media/img-testicon-question.3ad75c52.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};